<template>
  <div class="modern-card chat-card">
    <div class="card-header">
      <h3>AI Assistant</h3>
      <el-tag type="primary">Powered by GPT</el-tag>
    </div>
    <div class="card-content">
      <div class="chat-messages" ref="chatContainer">
        <div v-if="!messages.length" class="empty-chat">
          <i class="el-icon-chat-dot-square"></i>
          <p>Start a conversation with your AI assistant</p>
        </div>
        <div v-else>
          <div v-for="(message, index) in messages" :key="index" 
               :class="['message', message.type === 'user' ? 'message-user' : 'message-assistant']">
            <div class="message-content">
              <p>{{ message.text }}</p>
              <span class="message-time">{{ message.time }}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="chat-input">
        <el-input 
          placeholder="Ask me anything about bioinformatics..." 
          v-model="msg" 
          @keyup.enter.native="send"
          class="modern-input">
          <el-button slot="append" type="primary" @click="send" :disabled="!msg.trim()">
            <i class="el-icon-s-promotion"></i>
          </el-button>
        </el-input>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChatInterface',
  data () {
    return { 
      msg: '', 
      messages: [] 
    }
  },
  methods: {
    send () {
      if (!this.msg.trim()) return
      this.messages.push({ 
        text: this.msg, 
        time: new Date().toLocaleTimeString(),
        type: 'user'
      })
      this.msg = ''
      
      // Simulate AI response
      setTimeout(() => {
        this.messages.push({
          text: 'Thank you for your question! I\'m here to help with your bioinformatics analysis.',
          time: new Date().toLocaleTimeString(),
          type: 'assistant'
        })
      }, 1000)
    }
  }
}
</script>

<style scoped>
/* Add any specific styles for ChatInterface here */
</style> 